import { render, staticRenderFns } from "./order.vue?vue&type=template&id=3c088c92&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=3c088c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c088c92",
  null
  
)

export default component.exports